export default __webpack_public_path__ + "64fdb9200ae73c0e260991bcef5570db.woff2";